/*
 * @Author: Tommy Chen
 * @Date: 2024-03-19
 * @LastEditTime: 2025-05-23
 * @LastEditors: Tommy Chen
 * @Description: 埋点管理工具
 * @FilePath: /macc.admin.vue/src/utils/statisticsMgr.js
 */
import { loadSensors } from './sensors.js';
/**
 * 初始化统计组件
 * @param {Object} options - 配置选项
 * @param {Object} options.store - Vuex store实例
 * @returns {Promise<boolean>} 初始化是否成功
 */
export async function initStatisticsComp(options) {
  const host = window.location.host;
  window.sensors = null;

  // cookie中的明确配置不允许采集时，不进行采集
  let cookieStatisticSetting = true;
  const cookieSettingStr = localStorage.getItem('_RC_COOKIE_KEY_SETTING');
  if (cookieSettingStr) {
    const cookieSettingJson = JSON.parse(cookieSettingStr);
    cookieStatisticSetting = cookieSettingJson.statistic !== false;
  }
  if (!cookieStatisticSetting) {
    return false;
  }

  // 亚洲、国内开放神策埋点
  // if (
  //   [
  //     'noc.ruijie.com.cn',
  //     'cloud-as.ruijienetworks.com',
  //     'demotest.rj.link',
  //     'maccdemo.rj.link',
  //   ].includes(host)
  // ) {
    await loadSensors();
  // }
}
